var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  pluginRegistry.registerFeature("Octopus.Features.SubstituteInFiles", function() {
    return {
      title: "Substitute variables in files",
      description: "Transforms files using the Octopus <code>#{Variable}</code> substitution syntax",
      editTemplateUrl: "areas/projects/features/Octopus.Features.SubstituteInFiles_edit.html",
      priority: 22,
      editLink: function($scope, element) {
      },
      enable: function(action, step) {
        action.Properties["Octopus.Action.SubstituteInFiles.Enabled"] = "True";
      },
      disable: function(action, step) {
        delete action.Properties["Octopus.Action.SubstituteInFiles.TargetFiles"];
        delete action.Properties["Octopus.Action.SubstituteInFiles.OutputEncoding"];
      }
    };
  });

});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.SubstituteInFiles.js
// module id = 593936680783740
// module chunks = 1